{
  "welcome": {
    "title": "Barka da zuwa, {{name}}",
    "title_noName": "Barka da zuwa Rhemn",
    "body": "Duk abin da ke haske zai nuna maka abin da yake yi. Bincika ta kowane tsari, a duk lokacin da kake so.",
    "start": "Fara bincike",
    "later": "Ba yanzu ba"
  },
  "card": {
    "tryIt": "Gwada shi",
    "takeALook": "Duba",
    "pro": "Wani ɓangare na Rhemn Pro",
    "close_aria": "Rufe"
  },
  "pill": {
    "progress": "An bincika {{count}} cikin {{total}}",
    "progress_short": "{{count}} cikin {{total}}",
    "done": "An gama",
    "done_aria": "Kammala bincike",
    "complete": "An bincika duka"
  },
  "sr": {
    "started": "Yanayin bincike yana kunne. Maɓallai suna nuna abin da suke yi kafin su yi aiki.",
    "hint": "Yanayin bincike. Yana nuna abin da wannan yake yi da farko.",
    "ended": "Yanayin bincike a kashe yake."
  },
  "settings": {
    "row": "Yadda Rhemn ke aiki",
    "row_sub": "Taƙaitaccen kallo ga kowane ɓangare",
    "row_aria": "Yadda Rhemn ke aiki: sake bincika manhajar",
    "helpCaption": "Taimako"
  },
  "steps": {
    "intention": {
      "title": "Niyyar yau",
      "body": "Rubuta abu ɗaya mafi muhimmanci a yau, kuma ka yi masa alama idan ka gama."
    },
    "now": {
      "title": "Ranarka, bisa sallah",
      "body": "Rhemn yana raba ranarka a kowace sallah. Wannan yana nuna lokacin da ya rage kafin sallah ta gaba, da abin da ka tsara mata."
    },
    "verse": {
      "title": "Fahimtar aya",
      "body": "Yi tambaya game da ayar yau, karanta taƙaitaccen tafsiri, kuma ka nemo ayoyi masu jigo iri ɗaya."
    },
    "qibla": {
      "title": "Alƙibla",
      "body_chrome": "Inda Ka'aba take daga wurin da kake, a matsayin kusurwa daga arewa.",
      "body_ios": "Yana nuna hanyar Ka'aba daga wurin da kake. Kunna kamfas kai tsaye, zai bi ka yayin da kake juyawa."
    },
    "prayer": {
      "title": "Lokutan sallah",
      "body_chrome": "Lokutan salloli biyar na yau don wurin da kake. Zaɓi hanyar lissafi da masallacinka ke bi.",
      "body_ios": "Sallarka ta gaba a taƙaice. Buɗe ta don ganin lokuta biyar da tunatarwa ga kowace."
    },
    "tasks": {
      "title": "Ayyuka",
      "body": "Ajiye ayyukanka cikin jeri, kuma ka ba kowanne wuri tsakanin salloli."
    },
    "notes": {
      "title": "Bayanai",
      "body_chrome": "Rubuta, ko kawai ka yi magana. Rhemn yana rubuta bayanan murya da tarurrukanka, sannan ya taƙaita su.",
      "body_ios": "Rubuta, ko kawai ka yi magana. Rhemn yana mayar da abin da ka faɗa zuwa bayanai masu tsabta da aka taƙaita."
    },
    "profile": {
      "title_chrome": "Bayananka",
      "body_chrome": "Saitunan asusunka da na sirri. Dawo nan don sake bincika Rhemn.",
      "title_ios": "Ƙari",
      "body_ios": "Ayoyin da aka ajiye, Alƙibla, da saitunan asusunka. Kana iya sake bincika Rhemn daga nan."
    }
  }
}
